module.exports = __webpack_public_path__ + "img/Photo_6___Fourth_Canal_Ship_docked_West_St_976_281_2.7a247339.jpg";